function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1668 15.6667H10.8335C10.1918 15.6667 9.66683 15.1417 9.66683 14.5H1.51183V19.1667C1.51183 20.45 2.56183 21.5 3.84516 21.5H20.1668C21.4502 21.5 22.5002 20.45 22.5002 19.1667V14.5H14.3335C14.3335 15.1417 13.8085 15.6667 13.1668 15.6667ZM21.3335 5.16667H16.6668C16.6668 2.58833 14.5785 0.5 12.0002 0.5C9.42183 0.5 7.3335 2.58833 7.3335 5.16667H2.66683C1.3835 5.16667 0.333496 6.21667 0.333496 7.5V11C0.333496 12.295 1.37183 13.3333 2.66683 13.3333H9.66683V12.1667C9.66683 11.525 10.1918 11 10.8335 11H13.1668C13.8085 11 14.3335 11.525 14.3335 12.1667V13.3333H21.3335C22.6168 13.3333 23.6668 12.2833 23.6668 11V7.5C23.6668 6.21667 22.6168 5.16667 21.3335 5.16667ZM9.66683 5.16667C9.66683 3.88333 10.7168 2.83333 12.0002 2.83333C13.2835 2.83333 14.3335 3.88333 14.3335 5.16667H9.65516H9.66683Z",
  fill: "#007AFF"
});

function SvgManagementAccounts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagementAccounts);
export default __webpack_public_path__ + "static/media/managementAccounts.75fa7c13.svg";
export { ForwardRef as ReactComponent };